import React from 'react';
import { AsDatePicker } from '@adserve/adserve-react-components';
import { useLiveContentDayReportContext } from './contexts/LiveContentDayReportContext';

const labelStyle = {
    display: 'block',
    fontSize: 12,
    color: '#414141',
    marginBottom: 3
};
const style = {
    position: 'relative',
    display: 'flex',
    marginTop: 1,
    marginBottom: -1
};
const inputStyle = {
    color: '#414141',
    width: 150,
    height: 39,
    textAlign: 'left',
    padding: '0 24px',
    borderRadius: '5px 0 0 5px'
};
const buttonStyle = {
    height: 39
};

const InnerSelectDate = (props) => {
    const onChange = (ev) => props.handleSelectDate(ev.target.value);

    return (
        <div>
            <label htmlFor='date-select' style={labelStyle} >{window.translate('Date')}</label>
            <AsDatePicker
                id='date-select'
                currentDate={props.selectedDate}
                onChange={onChange}
                dateFormat={'DD MMM YYYY'}
                style={style}
                inputStyle={inputStyle}
                buttonStyle={buttonStyle}
                showPrevNextButtons={true}
            />
        </div>
    );
}

const CachedSelectDate = React.memo(InnerSelectDate);

export const SelectDate = () => {
    const { selectedDate, handleSelectDate } = useLiveContentDayReportContext();

    return <CachedSelectDate
        selectedDate={selectedDate}
        handleSelectDate={handleSelectDate}
    />;
};